/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppRoutes } from "src/app/constants";

import { SettingsPage } from "./settings.page";

const routes: Routes = [
  {
    path: "",
    component: SettingsPage,
  },
  {
    path: AppRoutes.profile,
    loadChildren: () => import("../../pages/profile/profile.module").then(m => m.ProfilePageModule),
  },
  {
    path: AppRoutes.companyProfile,
    loadChildren: () => import("../../pages/company-profile/company-profile.module").then(m => m.CompanyProfilePageModule),
  },
  {
    path: `${AppRoutes.companyProfile}/${AppRoutes.logo}`,
    loadChildren: () => import("../../pages/logo/logo.module").then(m => m.LogoPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsPageRoutingModule {}
